require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./scribbling-about-lost-data.json") })
        }
      }, "path---scribbling-about-lost-data");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---scribbling-about-lost-data!./.cache/json/scribbling-about-lost-data.json
// module id = 557
// module chunks = 231608221292675